import React, {useState} from 'react';
import { Controller } from 'react-hook-form';
import _ from 'lodash';
import clsx from 'clsx';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next';
import GroupSelect from './GroupSelect';
import { groupByDisabled } from 'utils/select';

export default function SubgroupSelect({accesses}) {
  const { t } = useTranslation();
  const methods = useFormContext()
  const [opened, setOpened] = useState(!!methods.formState.errors.group_ids)
  const toggle = (event) => {
    event.preventDefault()
    event.stopPropagation()

    setOpened(!opened)
  }

  return (
    <>
      <div>
        <span className='u-txt--label'>{t('administration.staff.subgroups.title')}</span><br />
        <Controller
          name='subgroup_ids'
          control={methods.control}
          render={({ field: { onChange, value } }) => (
            <Select
              name='sp-group-select'
              className={clsx('o-select o-select--optgroup', { 'o-select--error': _.get(methods.formState.errors, 'subgroup_ids') })}
              isMulti
              value={(accesses.data?.subgroups ?? []).filter(o => (value || []).includes(o.value))}
              onChange={(v) => {
                onChange(v.map(v => v.value));
              }}
              options={groupByDisabled(accesses.data?.subgroups ?? [])}
            />
          )}
        />
        {methods.formState.errors.subgroup_ids && (<p className='u-txt--error'>{methods.formState.errors.subgroup_ids.message}</p>)}
        <p className='u-txt--label'>{t('administration.staff.subgroups.info')}</p>
      </div>
      <div>
        <a href='#' onClick={toggle}>
          <span style={{marginRight: '8px'}}>
            {opened ? <i className='fa fa-chevron-down'></i> : <i className='fa fa-chevron-right'></i>}
          </span>
          {t('administration.staff.subgroups.giveHigherAccess')}
        </a>
        <div style={{marginLeft: '16px'}}>
          {opened && (
            <p>
              <GroupSelect accesses={accesses} />
            </p>
          )}
        </div>
      </div>
    </>
  )
}

SubgroupSelect.propTypes = {
  accesses: PropTypes.object.isRequired,
};
